import React, { FC } from 'react';

import { TEXTS } from 'application/pages/BillingPage/renderer/texts';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';

import useLicensesModalActions from '../../model/useLicensesModalActions';
import ChangeAutoRenewalButton from '../ChangeAutoRenewalButton/ChangeAutoRenewalButton';
import { LicensesModalActionsProps } from './licensesModalActionsProps';

const LicensesModalActions: FC<LicensesModalActionsProps> = ({
  viewMode,
  bindCardVisible,
  isSubmitLoading,
  isPendingAcceptanceAdvanced,
  hasSberConnection,
  isChangeAutoRenewalButtonDisabled,
  licensesSubscriptionCost,
  isLinkingInProcess,
  isHintShow,
  isNeedPayment,
  close,
  ...actionsProps
}) => {
  const { handleBindCard, handleChangeAutoRenewal, setEditMode, openAcceptanceAdvancedSigning } =
    useLicensesModalActions({ ...actionsProps, isNeedPayment, close });

  if (viewMode) {
    return (
      <>
        <Button
          key="button_view_mode_ok"
          elementId="button_view_mode_ok"
          type={ButtonType.PRIMARY}
          onClick={() => close()}>
          {TEXTS.BILLING_LICENSES_OK}
        </Button>

        <Button
          key="button_view_mode_set_edit"
          elementId="button_view_mode_set_edit"
          type={ButtonType.SECONDARY}
          onClick={setEditMode}>
          {TEXTS.BILLING_LICENSES_SET_EDIT_MODE}
        </Button>
      </>
    );
  }

  return (
    <>
      {bindCardVisible && (
        <Button
          elementId="button_bind_card"
          type={ButtonType.PRIMARY}
          isLoading={isSubmitLoading}
          onClick={handleBindCard}>
          {TEXTS.BILLING_BIND_CARD_BUTTON_TEXT}
        </Button>
      )}

      {isPendingAcceptanceAdvanced && (
        <Button
          elementId="button_acceptance_advanced_open"
          type={ButtonType.PRIMARY}
          isDisabled={!hasSberConnection}
          onClick={() => {
            openAcceptanceAdvancedSigning();
            close();
          }}>
          {TEXTS.BILLING_LICENSES_ACCEPTANCE_ADVANCED_TEXT}
        </Button>
      )}

      <ChangeAutoRenewalButton
        key="button_submit_licenses"
        isDisabled={isChangeAutoRenewalButtonDisabled || isPendingAcceptanceAdvanced}
        isLoading={isSubmitLoading}
        isNeedPayment={isNeedPayment}
        licensesSubscriptionCost={licensesSubscriptionCost}
        isLinkingInProcess={isLinkingInProcess}
        isHintShow={isHintShow}
        isPendingAcceptanceAdvanced={isPendingAcceptanceAdvanced}
        onClick={handleChangeAutoRenewal}
      />
    </>
  );
};

export default React.memo(LicensesModalActions);
